import React from 'react';

import './StepCopyWrokspaceSettings.scss';

export default ({ nextStep }: { nextStep?: () => void }): JSX.Element => {
  return <p>StepCopyWrokspaceSettings</p>;
};
